import type { WithActiveBranchId } from '@app/api/shared';

export enum SidebarEndpoints {
  GetSidebarCounters = 'GetSidebarCounters',
}

export interface ModelSidebarCounters {
  CountLeads: number;
  CountCrmTasks: number;
}

export type GetSidebarCountersRequest = Partial<WithActiveBranchId>;

export type GetSidebarCountersResponse = ModelSidebarCounters;
